import PropTypes from 'prop-types';
import React from 'react';
import sanitizeHtml from 'sanitize-html';

export class SectionHeader extends React.Component {
  sectionTextMarkup = () => {
    let labelText = '<h2>' + this.props.text + '</h2>';
    labelText = labelText.replace('<span style="text-decoration:underline;">', '<u>');
    labelText = labelText.replace('</span>', '</u>');
    const clean = sanitizeHtml(labelText, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(['u', 'h2', 'strong']),
    });
    const html = { __html: clean };
    return html;
  };

  render() {
    const sectionHeaderTextId = 'section_header_text' + this.props.id;

    return (
      <div className="section-header">
        <div
          data-qa-item={ sectionHeaderTextId }
          dangerouslySetInnerHTML={ this.sectionTextMarkup() }
        />
      </div>
    );
  }
}

SectionHeader.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  text: PropTypes.string,
};
